import React from 'react'
import { Clock } from 'lucide-react'
import { cn } from 'design-system'
import {
  formatNotificationTime,
  getNotificationColor,
  notificationColorMap,
  notificationIconMap,
  type NotificationItem,
} from './notificationUi'
import type { TFunction } from 'i18next'

type Props = {
  notification: NotificationItem
  onClick: (notification: NotificationItem) => void
  t: TFunction
  className?: string
  showBranchName?: boolean
}

export const NotificationListItem = ({
  notification,
  onClick,
  t,
  className,
  showBranchName = false,
}: Props) => {
  const IconComponent = notificationIconMap[notification.type] || notificationIconMap.default
  const colorKey = getNotificationColor(notification.type)
  const colorClass = notificationColorMap[colorKey] || notificationColorMap.primary

  return (
    <button
      type="button"
     
      className={cn(
        'flex w-full items-start gap-3 px-4 py-3 text-start transition-colors hover:bg-muted/80',
        !notification.read && 'bg-muted/40',
        className
      )}
      onClick={() => onClick(notification)}
    >
      <div className={cn('flex h-8 w-8 shrink-0 items-center justify-center rounded-full', colorClass)}>
        <IconComponent className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <h6 className="mb-1 mt-0 text-sm font-medium leading-snug text-foreground">{notification.title}</h6>
        <p className="mb-1 text-xs text-muted-foreground">{notification.message}</p>
        <p className="mb-0 text-[11px] font-medium text-muted-foreground">
          <span className="inline-flex flex-wrap items-center gap-x-2 gap-y-0.5">
            <span className="inline-flex items-center gap-1">
              <Clock className="h-3 w-3 shrink-0" />
              {formatNotificationTime(notification.created_at, t)}
            </span>
            {showBranchName && notification.branch_name ? (
              <span className="truncate">{notification.branch_name}</span>
            ) : null}
          </span>
        </p>
      </div>
      {!notification.read && (
        <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-primary ring-2 ring-primary/20" aria-hidden />
      )}
    </button>
  )
}
